export default {
  LogoImg: "https://shouqu.oss-cn-shanghai.aliyuncs.com/cms/160/images/1662708675515389218.png",
  AppId: 2,
  userChannelId: 6
}